import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { googleRequest, googleError } from '../lib/directGoogle';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { loginUser } = useAuth();
  const ran = useRef(false);
  const [error, setError] = useState('');
  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    (async () => {
      try {
        const flow = await googleRequest('/google/flow', undefined, 'GET');
        if (flow.mode === 'link' || !flow.known) { navigate('/auth/continue', { replace: true }); return; }
        const result = await googleRequest('/google/complete');
        await loginUser(result.access_token, result.user);
        if (localStorage.getItem('token') === result.access_token) navigate(result.next || '/', { replace: true });
      } catch (e) { setError(googleError(e)); }
    })();
  }, [navigate, loginUser]);
  return <main className="min-h-screen flex items-center justify-center bg-background text-foreground p-6">
    <div className="max-w-md text-center space-y-4"><p>{error || 'Loggar in…'}</p>
      {error && <button className="underline" onClick={() => navigate('/login')}>Tillbaka till inloggning</button>}
    </div></main>;
}
